export const environment = {
  production: true,
  buildId: '197602851109491',
};
